import React, { FC, Fragment } from 'react'
import { ASSETS } from '../../../../constants/assets'
import ImgUtil from '../../../../utils/img.utils'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type Props = {
  productDownloadData: any
}

export const GenerateLogos: FC<Props> = ({ productDownloadData }) => {
  return (
    productDownloadData.products?.map((product: any, i: number) => {
      const productName = product.text || ''
      const productLogo = product.tileMedia?.image?.file?.url || 'UiPath Logo'
      const productLogoAlt = product.tileMedia?.altText || 'UiPath Logo'

      return (
        <Fragment key={`product-logo--${i}`}>
          <div className="ProductDownload__Download-Product-Item">
            <WrapperImage
              className="ProductDownload__Download-Product-Logo"
              src={ImgUtil.getResizedImageUrl(productLogo, `width=250`)}
              alt={productLogoAlt}
              threshold={650}
            />

            <Typography type="bodyXS" className="ProductDownload__Product-Description font__inter">
              {productName}
            </Typography>
          </div>

          {i !== productDownloadData.products.length - 1 && (
            <WrapperImage
              className="ProductDownload__Plus-Icon"
              src={ImgUtil.getResizedImageUrl(ASSETS.PLUS_ICON, `width=50`)}
              alt="Plus Icon"
              threshold={650}
            />
          )}
        </Fragment>
      )
    }) || null
  )
}

export const GenerateCustomerLogos: FC<Props> = ({ productDownloadData }) => {
  return (
    productDownloadData.logos?.map((logo: any, i: number) => {
      const altText = logo.altText || 'Customer logo'
      const image = logo.image?.file?.url || '/'

      return (
        <WrapperImage
          src={ImgUtil.getResizedImageUrl(image, `width=200`)}
          alt={altText}
          key={`Customer-Logo--${i}`}
          className="ProductDownload__Customer-Logo-File"
          threshold={650}
        />
      )
    }) || null
  )
}
